
    const isSSR = typeof window === "undefined";
    const loadingModule = import('/Users/seehow/alibabacloud-console-chart/site/node_modules/@alicloud/gatsby-theme-console-doc/lib/buildtime/.cache/bb7324439dec9bca0945095439ba8c45--le-chart）packages）console-bar-chart）demo）Facet.tsx').catch(reason => {
      // 服务端渲染的时候，忽略异步引入的模块中的错误（可能是因为使用了window对象）
      if (isSSR) return;
      throw reason;
    });
    export default loadingModule;
    export const _demoInfo = __demo_loader_placeholder__;    
